import {Button, Form, message, notification, Select, Table, Tabs, Typography, Upload, Spin} from "antd";
import StringSimilarity from "string-similarity";
import {v4} from "uuid";
import HecRasHelper from "../Helpers/HecRasHelper";
import FileHelper from "../Helpers/FileReader";
import {useEffect, useRef, useState} from "react";
import {InboxOutlined} from "@ant-design/icons";
import {DefaultProject} from "../Context/ProjectContext";
import ProjectMD5 from "../Helpers/ProjectMD5";
import {useUser} from "../Context/UserContext";

const { Dragger } = Upload;

export const PlanTypes = [
    {label: 'Effective', match: 'Effective',},
    {label: 'Duplicate Effective', match: 'Duplicate Effective DE',},
    {label: 'Corrected Effective', match: 'Corrected Effective CE',},
    {label: 'Existing', match: 'Existing',},
    {label: 'Proposed', match: 'Proposed',},
    {label: 'Revised', match: 'Revised REV',},
    {label: 'Multiple Run', match: 'Multiple Run',},
    {label: 'Floodway Run', match: 'Floodway Run',},
    {label: 'Defined Future', match: 'Defined Future DF',},
    {label: 'Grid Mapping', match: 'Grid Mapping',},
    {label: 'Calibration', match: 'Calibration',},
]

export const PlanProfiles = [
    {label: 'FW', value: 'FW', match: 'FW'},
    {label: '2yr (50%)', value: 'YR2', match: '2YR50%'},
    {label: '10yr (10%)', value: 'YR10', match: '10YR10%'},
    {label: '25yr (4%)', value: 'YR25', match: '25YR4%'},
    {label: '50yr (2%)', value: 'YR50', match: '50YR2%'},
    {label: '100yr (1%)', value: 'YR100', match: '100YR1%'},
    {label: '500yr (0.2%)', value: 'YR500', match: '500YR0.2%'},
    {label: 'Future 10%', value: 'FUT10', match: 'FUTURE10%'},
    {label: 'Future 20%', value: 'FUT20', match: 'FUTURE20%'},
    {label: 'Future 35%', value: 'FUT35', match: 'FUTURE35%'},
    {label: 'Future Ult', value: 'FUTULT', match: 'FUTUREULT'},
]

export default function ProjectUploader({onUploadProject}) {
    let dropFiles = []
    let dropFolder = null

    const [spin, setSpin] = useState(false)
    const [project, setProject] = useState({
        ...DefaultProject
    })
    const [files, setFiles] = useState([])
    const {user} = useUser()

    function containsOnlyNumbers(str) {
        return /^\d+$/.test(str);
    }

    function containsNumbers(str) {
        return /\d/.test(str);
    }

    const autoMapPlanType = (text, mapProfiles) => {
        text = text.toUpperCase()

        if(text.includes('ENCROACH'))
            return 'Floodway Run'

        if(text.includes('FLOODPLAIN') || text.toUpperCase().includes('MULTI'))
            return 'Multiple Run'

        if(text.includes('FUTURE'))
            return 'Defined Future'

        text = text.replaceAll('_', ' ')
        text = text.replaceAll('-', ' ')

        if(text.split(' ').find(x => x.trim() === 'DE'))
            text = text.replaceAll(' DE', ' DUPLICATE EFFECTIVE')

        if(text.split(' ').find(x => x.trim() === 'CE'))
            text = text.replaceAll(' CE', ' CORRECTED EFFECTIVE')

        if(text.split(' ').find(x => x.trim() === 'REV'))
            text = text.replaceAll(' REV', ' REVISED')

        let hasOnlyFW100 = false
        if(mapProfiles.length === 2 && mapProfiles.filter(x => x.target === 'FW' || x.target === 'YR100')) {
            hasOnlyFW100 = true
        }

        const matches = StringSimilarity.findBestMatch(text, PlanTypes.map(x => x.match.toUpperCase()));
        if(matches.bestMatch?.rating < 0.4) {
            return hasOnlyFW100 ? 'Floodway Run' : 'Multiple Run'
        }

        const index = matches.bestMatchIndex;
        return PlanTypes[index].label
    }

    const autoProfileMap = (text) => {
        text = text.toUpperCase()
        text = text.replaceAll('-', '')
        text = text.replaceAll('PCT', '%')
        text = text.replaceAll('(', '')
        text = text.replaceAll(')', '')
        text = text.replaceAll('@', '')
        text = text.replaceAll(' ', '')

        // if(text.includes('1%'))
        //     text = text.replace('1%', '100YR')

        if(text.includes('FW')) {
            return 'FW';
        }

        if(text.includes('1%10%')) {
            return 'FUT10'
        }

        if(text.includes('YEAR')) {
            text = text.replaceAll('YEAR', 'YR')
        }

        if(text.startsWith('02')) {
            text = text.replace('02', '0.2')
        }

        try {
            if(containsOnlyNumbers(text))
                text = `${text}YR`

            if(text === '500YR')
                return 'YR500'

            if(text.includes('FUT') && text.includes('100')) {
                return 'FUTULT'
            }

            if(text.startsWith('FC')) {
                text = text.replace('FC', 'FUTURE')
            }
        }
        catch (exp) {

        }

        if(text === '100YR10%') {
            return 'FUT10'
        }

        if(text === '100YR20%') {
            return 'FUT20'
        }

        if(text === '100YR35%') {
            return 'FUT35'
        }

        const matches = StringSimilarity.findBestMatch(text, PlanProfiles.map(x => x.match.toUpperCase()));
        const index = matches.bestMatchIndex;
        return PlanProfiles[index].value.toUpperCase()
    }

    const mapProjectFiles = async (dropFiles) => {
        allFiles = []
        dropFiles.forEach(files => {
            allFiles = [...allFiles, ...files.fileList.map(x => {
                return (x && x.originFileObj) || x
            })]
        })

        let files = [...allFiles]
        let folderName = dropFolder

        let groupedFiles = []
        for(let i=0; i<files.length; i++) {
            let file = files[i];

            const split = file.name.split('.');
            if(split.length < 2)
                continue

            const ext = split[split.length-1].toLowerCase();

            if(ext.includes('prj'))
            {
                const text = await FileHelper.readTextFile(file)
                const f = {
                    id: v4(),
                    fileName: file.name,
                    title: HecRasHelper.getProjectTitle(text),
                    descriptions: HecRasHelper.getProjectDescription(text),
                    text: text,
                    type: 'project'
                }

                groupedFiles.push(f)
            }
            else if(ext.startsWith('g'))
            {
                const text = await FileHelper.readTextFile(file)
                const f = {
                    id: v4(),
                    fileName: file.name,
                    ext,
                    title: HecRasHelper.getGeometryTitle(text),
                    text: text,
                    type: 'geometry'
                }

                groupedFiles.push(f)
            }
            else if(ext.startsWith('p'))
            {
                const text = await FileHelper.readTextFile(file)
                const version = HecRasHelper.getPlanVersion(text)
                const f = {
                    id: v4(),
                    fileName: file.name,
                    ext,
                    title: HecRasHelper.getPlanTitle(text),
                    shortIdentifier: HecRasHelper.getPlanShortIdentifier(text),
                    version: HecRasHelper.getPlanVersion(text),
                    text: text,
                    geometryFileExt: HecRasHelper.getGeometryFile(text),
                    flowFileExt: HecRasHelper.getFlowFile(text),
                    type: 'plan',
                    isMapped: false
                }

                groupedFiles.push(f)
            }
            else if(ext.startsWith('f'))
            {
                const text = await FileHelper.readTextFile(file)
                const profiles = HecRasHelper.getFlowProfiles(text);
                const f = {
                    id: v4(),
                    fileName: file.name,
                    ext,
                    title: HecRasHelper.getFlowTitle(text),
                    profiles: profiles,
                    text: text,
                    type: 'flow'
                }

                groupedFiles.push(f)
            }
            else if(ext.includes('txt')) {
                const text = await FileHelper.readTextFile(file)
                const f = {
                    id: v4(),
                    fileName: file.name,
                    ext,
                    title: file.name,
                    text: text,
                    type: 'output',
                    data: [],
                }

                if (f.fileName === 'output.txt') {
                    const out = HecRasHelper.parseAllOutputProfiles(f.text);
                    if(out.length > 1)
                        f.data = HecRasHelper.parseAllOutputProfiles(f.text).filter(x => x.Plan)
                    else
                        f.data = out;
                    groupedFiles.push(f)
                }
            }
        }

        let projectFiles = []
        const _planFiles = groupedFiles.filter(x => x.type === 'plan');
        const output = groupedFiles.find(y => y.type === 'output')

        _planFiles.forEach(plan => {
            const fileName = plan.fileName.split('.')[0]

            let flowFile = groupedFiles.find(y => plan.flowFileExt?.includes(y.ext) && y.fileName?.includes(fileName))
            if(!flowFile)
                flowFile = groupedFiles.find(y => plan.flowFileExt?.includes(y.ext))

            let geoFile = groupedFiles.find(y => plan.geometryFileExt?.includes(y.ext) && y.fileName?.includes(fileName))
            if(!geoFile)
                geoFile = groupedFiles.find(y => plan.geometryFileExt?.includes(y.ext))

            if(!geoFile)
            {
                return
            }

            if(!flowFile)
            {
                return
            }

            let profileData = {}
            if(output) {
                if(output.data.length === 1) {
                    profileData = output.data[0]
                }
                else {
                    profileData = output.data.find(x => x.Plan.trim() === plan.title.trim() || x.Plan === plan.shortIdentifier.trim())
                    if(!profileData)
                        profileData = output.data.find(x => x.Plan.trim() === flowFile.title.trim() || x.Plan.trim() === geoFile.title.trim())
                }
            }

            const mapProfiles = flowFile ? flowFile.profiles.map(x => {
                const key = autoProfileMap(x);
                return {select: x, target: key, targetName: PlanProfiles.find(x => x.value === key).label}
            }) : []

            projectFiles.push({
                id: v4(),
                plan: plan,
                geometry: geoFile,
                flow: flowFile,
                mapProfiles: mapProfiles,
                profileData: profileData,
                mappedProfiles: HecRasHelper.mapProfiles(profileData, mapProfiles),
                type: autoMapPlanType(plan.title, mapProfiles),
                isMapped: true
            })
        })

        const information = groupedFiles.find(x => x.type === 'project');

        return {
            information: {
                ...information,
                folderName,
                outputColumns: HecRasHelper.checkColumns(output?.text),
                hasOutputFile: output ? 'true' : 'false',
            },
            projectFiles: [...projectFiles],
            files: groupedFiles,
        }
    }

    useEffect(() => {
        if(project && project.type !== 'def') {
            project.projectFiles = project?.projectFiles?.map(prj => {
                return {
                    ...prj,
                    projectHash: ProjectMD5({
                        email: user.data.email,
                        projectTitle: project.information.title,
                        flowTitle: prj.flow.title,
                        flowFile: prj.flow.fileName,
                        geoTitle: prj.geometry.title,
                        geoFile: prj.geometry.fileName,
                        planTitle: prj.plan.title,
                        planFile: prj.plan.fileName
                    })
                }
            })

            project.projectFiles = project.projectFiles.filter(
                (obj, index) =>
                    project.projectFiles.findIndex((item) => item.projectHash === obj.projectHash) === index
            );

            onUploadProject(project)
        }
    }, [project])

    let timeout = null

    let allFiles = []
    const onChangeFiles = async (info) => {
        const path = info?.fileList[0]?.originFileObj?.webkitRelativePath;
        if(path && !dropFolder) {
            dropFolder = path.split('/')[0];
        }
        dropFiles.push(info)

        if(timeout) {
            clearTimeout(timeout)
            timeout = null
        }

        timeout = setTimeout(async () => {
            try {
                setSpin(true)
                const res = await mapProjectFiles(dropFiles)
                setProject(res)
                setSpin(false)
            } catch (exp) {
                console.log(exp)
            }
        }, 1500)
    }

    const onDrop = async (e) => {
        // if(e.dataTransfer.files && e.dataTransfer.files.length === 1 && !e.dataTransfer.files[0].type) {
        //     dropFolder = e.dataTransfer.files[0];
        // }
    }

    return (
        <>
            <Dragger
                onChange={onChangeFiles}
                onDrop={onDrop}
                multiple={true}
                showUploadList={false}
                beforeUpload={() => false}
                fileList={files}
                style={{padding: 16}}
                directory={true}
            >
                {
                    !spin && (
                        <>
                            <div className="ant-upload-text">
                                <table style={{width: '100%'}}>
                                    <tr>
                                        <td style={{width: '50%'}}>
                                            <div>
                                                <p className="ant-upload-drag-icon">
                                                    <InboxOutlined />
                                                </p>
                                                Drag & Drop
                                                <br/>
                                                or
                                                <br/>
                                                <Button>
                                                    Browse
                                                </Button>
                                                <br/>
                                                HEC-RAS Model Folder
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </>
                    )
                }
                {
                    spin && (
                        <>
                            <div style={{margin: 8}}>
                                <Spin tip="Loading" size="large">
                                    <div className="content" />
                                </Spin>
                            </div>
                        </>
                    )
                }
            </Dragger>
        </>
    )
}